'use client';


import React from 'react';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { getJsonData } from "@/lib/getJsonDataClient";

import 'swiper/css';
import 'swiper/css/pagination';

import  './HomeSlider.scss';

interface HomeSliderProps {
  variation: 'full-width' | 'half-width';
  slideshow: any[]; // ideally you define a better type
}

const HomeSlider: React.FC<HomeSliderProps> = ({ variation, slideshow }) => {
  if (!slideshow?.length) return null;


  return (
    <>


      <Swiper
        className={`home-slider ${variation}`}
        modules={[Navigation, Pagination, Scrollbar]}
        spaceBetween={0}  // Space between slides
        slidesPerView={1}  // Show 1 slide at a time
        navigation={false}  // Enable navigation buttons
        pagination={{ clickable: true }}  // Enable clickable pagination
        scrollbar={{ draggable: true }}  // Enable draggable scrollbar
        loop={true}  // Infinite looping
        autoplay={{ delay: 5000 }}  // Autoplay every 5 seconds
        effect="fade"  // Fade transition effect
        speed={1000}  // Slide transition speed
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
      >


      {slideshow.map((slide, index) => {
        const images = JSON.parse(slide['file-media-capture']);
        const imageUrl = images[0]?.link;

        return (

          <SwiperSlide key={index}>
          <div className="image-wrap">
            <Image
              src={imageUrl}
              alt={`Slide ${index + 1}`}
              fill
              style={{ objectFit: 'cover' }}
              loading="lazy"
            />
            <div className="swiper-lazy-preloader"></div>
          </div>
          <div className="caption--outer">
            <div className="caption">
              <div className="caption--inner">
              <h3>{slide['slideshow-text-1']}</h3>
                <h2>{slide['slideshow-text-2']}</h2>
                <p>{slide['slideshow-text-3']}</p>
                {slide.urls?.length > 0 && (
                    <p>
                      {slide.urls.map((cta: any, i: number) => (
                        <a key={i} href={cta['slide-cta-url']} className="button frame white">
                          {cta['slide-cta']}
                        </a>
                      ))}
                    </p>
                  )}
                </div>
                </div>
            </div>
          </SwiperSlide>



        );
      })}

      </Swiper>
      </>
  )
}
export default HomeSlider;